var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-textarea',{attrs:{"state":_vm.state,"placeholder":_vm.placeholder,"autocomplete":_vm.autocomplete,"rows":_vm.rows,"disabled":_vm.disabled,"size":_vm.size,"trim":""},on:{"input":_vm.handleInput,"blur":_vm.handleBlur},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }